"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.link = exports.SELF_REFERENCE = void 0;
exports.SELF_REFERENCE = "self";
/**
 * Sugar for creating a hypermedia
 *
 * @param rel Relationship of link to the resource
 * @param method The method required to call the API
 * @param href The endpoint of the api
 */
const link = (rel, method, href) => {
    return {
        rel,
        method,
        href
    };
};
exports.link = link;
//# sourceMappingURL=hypermedia.js.map